import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import payoutManagerReducer from '../reducers/payoutManagerReducer';

const configureStore = (railsProps) => (
  createStore(payoutManagerReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
